import React from "react";
import {connect} from "react-redux";
import {updatePage} from "../../actions/page";
import AccessGate from "../../components/permissions/AccessGate";
import {deleteContentWriterProject, getContentWriterProjects} from "../../actions/content_writer";
import {DEFAULT_DOMAINS_PER_PAGE} from "../../config";
import {displayErrors} from "../../libs/utils";
import {Alert, Card, Col, ConfigProvider, message, Popconfirm, Row, Select, Space, Table, Tag, Tooltip} from "antd";
import AccessItem from "../../components/permissions/AccessItem";
import Button from "antd/es/button";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import UndoOutlined from "@ant-design/icons/lib/icons/UndoOutlined";
import {DeleteOutlined, FolderOpenOutlined, SettingOutlined} from "@ant-design/icons";
import AddContentWriterProjectModal from "../../components/content/AddContentWriterProjectModal";
import {hasPermission} from "../../components/permissions/PermissionUtils";
import {DateTimeFormat} from "../../components/shared/DateTimeFormat";
import {Link} from "react-router-dom";
import WriterSettingsModal from "../../components/content/WriterSettingsModal";

class ContentProjects extends React.Component {
    state = {
        projects: [],
        filters: null,
        projectsLoaded: false,
        showAddModal: false,
        searchQuery: [],
        searching: false,
        showAddProjectModal: false,
        pagination: { current: 1, pageSize: DEFAULT_DOMAINS_PER_PAGE, showSizeChanger: true, total: 0 },
        showWriterSettingsModal: false,
    };

    componentDidMount() {
        this.props.updatePage(<span>Projects <Tag color='warning'>Beta</Tag></span>);
        this.loadProjects();
    }

    loadProjects(page = null, per_page = null, filters = null) {
        if(page === null) {
            page = this.state.pagination.current;
        }

        if(per_page === null) {
            per_page = this.state.pagination.pageSize;
        } else {
            if(per_page !== this.state.pagination.pageSize) {
                page = 1;
            }
        }

        if(filters === null) {
            filters = this.state.filters;
        }

        if(this.state.searchQuery.length > 0) {
            page = 1;
            this.setState({ searching: true });
        }

        this.setState({ domainsLoaded: false });

        this.props.getContentWriterProjects(page, per_page, this.state.searchQuery, filters, (response) => {
            this.setState({ projects: response.data.data,
                pagination: { current: response.data.page, pageSize: response.data.per_page, showSizeChanger: true, total: response.data.total }, projectsLoaded: true, searching: false });
        }, (err) => {
            this.setState({ projectsLoaded: true, searching: false });

            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
            }
        });
    }

    clearSearchAndLoadProjects() {
        this.setState({ searchQuery: []}, () => {
            this.loadProjects();
        });
    }

    runSearch() {
        if(this.state.searchQuery.length > 0) {
            this.loadProjects();
        }
    }

    updateSearchQuery(value) {
        if(value.length === 0) {
            return this.setState({ searchQuery: [] }, () => this.loadProjects());
        }

        let query = [];

        for(let i = 0; i < value.length; i++) {
            let item = value[i].trim();

            if(item !== '') {
                query.push(item)
            }
        }

        this.setState({ searchQuery: query });

        if(query.length === 0) {
            this.loadProjects();
        }
    }

    deleteProject(guid) {
        this.props.deleteContentWriterProject(guid, () => {
            message.success('Project deleted successfully!');
            this.loadProjects();
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
            }
        });
    }

    render() {
        if(this.props.company.domain_count === 0) {
            return <Alert type='info' showIcon message='Please add domains to your account before creating a content creation project!' />
        }

        const columns = [
            { title: 'Name', dataIndex: 'name', width: '30%', render: (item, record) => <Link to={'/content/' + record.guid}>{item}</Link> },
            { title: 'Articles', dataIndex: 'articles_count', align: 'center' },
            { title: 'Domain', dataIndex: 'domain', render: (item) => item.domain },
            { title: 'Created', dataIndex: 'date_created', render: (item) => <DateTimeFormat value={item} /> },
            { title: 'Tags', dataIndex: 'tags', width: '30%', render: (item) => item.map((tag) => <Tag key={tag}>{tag}</Tag>)},
        ];

        if(hasPermission(this.props.company.permissions, ['can_use_content_writer'])) {
            columns.push({ title: '', align: 'right', render: (item, record) => (
                <Popconfirm
                    title="Are you sure you want to delete this project?"
                    onConfirm={() => this.deleteProject(record.guid)}
                    okText='Delete'
                    placement='topLeft'
                    okButtonProps={{danger: true}}
                    cancelText='Cancel'>
                    <Tooltip title='Delete project' placement='left'>
                        <Button icon={<DeleteOutlined />} danger size='small' />
                    </Tooltip>
                </Popconfirm>
            )});
        }

        return <AccessGate scopes={['can_view_content_writer']}>
            <Card size='small'>
                <Row justify='space-between' style={{paddingBottom: '10px'}}>
                    <Col>
                        <Space>
                            <AccessItem scopes={['can_use_content_writer']}>
                                <Space>
                                    <Button className='add-domain-group-btn' icon={<PlusOutlined />} onClick={() => this.setState({ showAddProjectModal: true })}>Add Project</Button>
                                    <Button icon={<SettingOutlined />} onClick={() => this.setState({ showWriterSettingsModal: true })}>Writer Settings</Button>
                                </Space>
                            </AccessItem>

                            <Select
                                value={this.state.searchQuery}
                                maxTagCount={50}
                                placeholder='Search by name, domain or tags...'
                                open={false}
                                maxTagTextLength={10}
                                onClear={() => this.clearSearchAndLoadProjects()}
                                onInputKeyDown={(e) => { if(e.key === 'Enter') { this.runSearch() }}}
                                allowClear loading={this.state.searching}
                                mode="tags" style={{ width: '250px' }}
                                onChange={(value) => this.updateSearchQuery(value)} tokenSeparators={[',', ' ']} />
                        </Space>
                    </Col>
                    <Col>
                        <Tooltip title='Reload table'>
                            <Button type='text' icon={<UndoOutlined />} onClick={() => this.loadProjects()}/>
                        </Tooltip>
                    </Col>
                </Row>

                <ConfigProvider renderEmpty={() => <div style={{textAlign: 'center'}}>
                    <FolderOpenOutlined style={{fontSize: 40}}/>
                    <p>Nothing to see here...</p>
                    <AccessItem scopes={['can_use_content_writer']}>
                        <Button icon={<PlusOutlined/>} onClick={() => this.setState({ showAddProjectModal: true })}>Add Project</Button>
                    </AccessItem>
                </div>}>
                    <div style={{overflowX: 'auto'}}>
                        <Table
                            dataSource={this.state.projects}
                            columns={columns}
                            rowKey={(item) => item.guid}
                            pagination={this.state.pagination}
                            onChange={(pagination) => this.loadProjects(pagination.current, pagination.pageSize)}
                            loading={!this.state.projectsLoaded}/>
                    </div>
                </ConfigProvider>
            </Card>

            <AddContentWriterProjectModal
                showModal={this.state.showAddProjectModal}
                history={this.props.history}
                close={(reload) => {
                    this.setState({ showAddProjectModal: false });

                    if(reload) {
                        this.loadProjects();
                    }
                }}/>

            <WriterSettingsModal
                showModal={this.state.showWriterSettingsModal}
                close={() => this.setState({ showWriterSettingsModal: false })} />
        </AccessGate>;
    }
}

const mapStateToProps = state => ({
    company: state.auth.user.user.company
});

export default connect(mapStateToProps, { updatePage, getContentWriterProjects,
    deleteContentWriterProject })(ContentProjects);